import styled from "styled-components";
import { theme } from "../../../config";

export const HeaderWrapper = styled.div`
  background: ${theme.colors.neutral.black8};
  margin-top: -10px;
  padding: 22px 0;
  text-align: center;
`;

export const Name = styled.p`
  font-family: Orkney Bold;
  font-size: 16px;
  line-height: 18px;
`;
